<div fxLayout="row" class="layout-row">
    @for (command of commands; track command) {
    @if (command.isVisible) {
    <command [command]="command" [dense]="dense" [useMouseDown]="useMouseDown"
        attr.telemetry="Command-{{command.label}}-CmdBar-Commands">
    </command>
    }
    }
</div>